import { render, staticRenderFns } from "./AnxTableContainer.vue?vue&type=template&id=35d78eab&scoped=true&"
import script from "./AnxTableContainer.vue?vue&type=script&lang=ts&"
export * from "./AnxTableContainer.vue?vue&type=script&lang=ts&"
import style0 from "./AnxTableContainer.vue?vue&type=style&index=0&id=35d78eab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d78eab",
  null
  
)

export default component.exports